import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const FILTER_KEY = 'filter';

export const useFilterFlyout = () => {
  return useOpenedStateManager(FILTER_KEY);
};
